import { useHasProfile } from "@dexteel/mesf-core";

export const useCalendarPermissions = () => {
	const hasProfile = useHasProfile();
	const canEditSchedule =
		hasProfile("Scheduler Profile") || hasProfile("admin Profile");
	const canAddDownDay =
		canEditSchedule ||
		hasProfile("Supervisor Profile") ||
		hasProfile("SubAdmin Profile");

	return {
		canEditSchedule,
		canAddDownDay,
	};
};
